import history from '@shared/innmaxLib/routes/history'
import { pathOr } from 'ramda'
import { ActionTypes, useAuth } from '.'
import { UserPermission } from './auth.types'

export function useRouteCRUDAuthCheck() {
  const { user } = useAuth()

  const routeAuth = pathOr(
    {},
    ['authByUrl', history.location.pathname],
    user
  ) as UserPermission

  return [
    routeAuth,
    (actionType: ActionTypes) =>
      process.env.NODE_ENV === 'development' ? true : routeAuth[actionType],
  ] as [UserPermission, (act: string) => boolean]
}
